import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { modulesResponse, type UseModules } from './Modules.schema';

const MODULES_QUERY_KEY = ['modules'];

export const modulesKeys = {
	all: MODULES_QUERY_KEY,
	list: () => [...MODULES_QUERY_KEY, 'list'] as const,
};

export const useModules = (opts: UseModules['opts'] = {}) =>
	useQuery<UseModules['response']>({
		...opts,
		queryKey: modulesKeys.list(),
		queryFn: () => API.get('/modules').then((res) => modulesResponse.parse(res.data)),
		// The list now carries per-module health, so we re-poll more often
		// than the static metadata would warrant. The backend caches health
		// for ~10s, so a 15s refetch hits cache most ticks.
		staleTime: 10_000,
		refetchInterval: 15_000,
	});
